import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Save, Download, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { toJpeg } from 'html-to-image';

export const ActionBar = ({ onSave, result }) => {
  const handleDownload = async () => {
    try {
      const element = document.querySelector('.result-panel');
      if (!element) { toast.error('未找到内容'); return; }
      const dataUrl = await toJpeg(element, { quality: 0.95 });
      const link = document.createElement('a');
      link.download = `${result?.destination || '旅行攻略'}.jpg`;
      link.href = dataUrl;
      link.click();
      toast.success('已下载图片');
    } catch (err) {
      toast.error('下载失败');
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({ title: result?.destination, text: result?.totalBudget });
    } else {
      toast.info('浏览器不支持分享功能');
    }
  };

  return (
    <Card className="border-0 shadow-card rounded-card bg-white">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button onClick={onSave} className="bg-primary hover:bg-primary-hover text-white rounded-btn px-5 shadow-btn hover:shadow-btn-hover">
            <Save className="w-4 h-4 mr-2" />
            保存行程
          </Button>
          <Button onClick={handleDownload} variant="outline" className="rounded-btn px-5 border-[#E8E4DF] text-text-primary hover:bg-bg-secondary">
            <Download className="w-4 h-4 mr-2" />
            下载图片
          </Button>
          <Button onClick={handleShare} variant="outline" className="rounded-btn px-5 border-[#E8E4DF] text-text-primary hover:bg-bg-secondary">
            <Share2 className="w-4 h-4 mr-2" />
            分享
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
